// 综合管理
export default [
  {
    path: '/account',
    name: 'account',
    meta: {
      requireAuth: true,
      keepAlive: true
    },
    component: (resolve) => {
      require(['@/views/authority/account.vue'], resolve)
    }
  },
  {
    path: '/employeesConfig',
    name: 'employeesConfig',
    meta: {
      requireAuth: true,
      keepAlive: true
    },
    component: (resolve) => {
      require(['@/views/authority/employeesConfig.vue'], resolve)
    }
  },
  {
    path: '/role',
    name: 'role',
    meta: {
      requireAuth: true,
      keepAlive: true
    },
    component: (resolve) => {
      require(['@/views/authority/role.vue'], resolve)
    }
  },
  {
    path: '/fileConfig',
    name: 'fileConfig',
    meta: {
      requireAuth: true,
      keepAlive: true
    },
    component: (resolve) => {
      require(['@/views/authority/fileConfig.vue'], resolve)
    }
  },
  {
    path: '/userConfig',
    name: 'userConfig',
    meta: {
      requireAuth: true,
      keepAlive: true
    },
    component: (resolve) => {
      require(['@/views/authority/userConfig.vue'], resolve)
    }
  },
  {
    path: '/weChatConfig',
    name: 'weChatConfig',
    meta: {
      requireAuth: true,
      keepAlive: true
    },
    component: (resolve) => {
      require(['@/views/authority/weChatConfig.vue'], resolve)
    }
  },
  {
    path: '/operateConfig',
    name: 'operateConfig',
    meta: {
      requireAuth: true,
      keepAlive: true
    },
    component: (resolve) => {
      require(['@/views/authority/operateConfig.vue'], resolve)
    }
  }

]



// WEBPACK FOOTER //
// ./src/router/authority.js